<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <!-- <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Document Access Logs Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br>
                <v-row justify="center">
                    <v-col cols="12" sm="4">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="document_category" return-object
                            :items="document_category_list" item-text="category_name" label="Select Document Category"
                            outlined persistent-hint hint="Please Select Document Category"
                            @change="get_document_sub_category()" />
                    </v-col>

                    <div></div>
                    <v-col cols="12" sm="4" v-if="document_sub_category_list != '' && document_category != ''">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="document_sub_category"
                            return-object :items="document_sub_category_list" item-text="subcat_name"
                            label="Select Document Sub Category" outlined persistent-hint
                            hint="Please Select Document Sub Category" />
                    </v-col>
                    <v-col>
                        <v-btn class="button" :loading="loader" @click="FetchReport" dense>Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card> -->

            <v-card class="box" v-if="documents_Access_log_list != ''">
                <v-data-table :headers="headers_2" :items="documents_Access_log_list">
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Document Access Logs List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                </v-data-table>

            </v-card>

        </v-container>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
    data: () => ({

        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,

        instructor_list: [],

        instructor: "",
        documentcategory: "",
        document_sub_category_list: [],
        document_category_list: [],
        document_category: "",
        document_sub_category: "",
        ay_list: [], ay: "",
        documents_Access_log_list: [], basepath: null,

        headers_2: [
            {
                text: "Sr.No",
                value: "srno",
            },
            {
                text: "Access Date",
                value: "access_date",
            },
            {
                text: "Document Name",
                value: "document_name",
            },
            {
                text: "Document Access For",
                value: "documentaccesscontrolmaster",
            },

            {
                text: "Instructor",
                value: "instructor",
            },

        ],

    }),

    methods: {

        onLoad() {
            this.overlay = true;
            axios.post("/AMC/getDocumentsAccesslogsReport")
                .then(res => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.documents_Access_log_list = res.data.documents_access_log_list;
                    } else {
                        this.showSnackbar("red", res.data.Message);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch(error => {
                    this.overlay = false; // Hide overlay if there's an error
                    console.error(error);
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {},
};
</script>
<style scoped></style>